import React, { useState } from 'react';
import { X } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const images = [
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/u6m9aaum_IMG_6303.webp',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/876io4mg_B80630D4-AFCB-46A0-A1A5-56C75BC40628.jpeg',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/k9d3zvam_7F59264F-15DF-4795-ACD2-19A7124D9092.jpeg',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/0003w5qj_B903065A-B36F-4F7A-A38F-F7B2434A61D5.jpeg',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/r4gmbe0i_713A1D33-3098-4E06-B3F0-36EF3F58E1EC.webp',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/lalbqpwm_9E384E94-E3BC-41C7-93C1-D3D3BC3C8DB3.webp',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/pj39degt_att.mIVWAZnduMZ8-ZOTJQqSPqq2wYYOXQffDDq-w-y-TcA.webp',
  'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/neg5lq60_56FE6F5B-52E1-4C7D-93A4-E93D168BEE48.webp',
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_intelligent-shtern-10/artifacts/omnmj43m_att.9v5qxwG_y9xxiR8a7-_RBrUQpyWTp4VAkA2f2Tpo9Vk.webp',
];

const Gallery = () => {
  useSEO({
    title: 'Galerii — meie ruumid ja hetked | Prestige Beauty & Wellness',
    description:
      'Piilu sisse Prestige Beauty & Wellnessi hubasetesse ruumidesse ja saa aimu meie hoolduskogemusest ja miljööst Pärnus.',
    path: '/galerii',
  });
  const [active, setActive] = useState(null);

  return (
    <div>
      <section className="hero-bg pt-36 pb-20 px-6 text-center">
        <h1 className="section-title text-4xl md:text-5xl mt-4 fade-up">Meie ruumid ja hetked</h1>
        <div className="mt-6 flex justify-center fade-up"><span className="gold-divider" /></div>
        <p className="text-brand-muted mt-8 max-w-2xl mx-auto fade-up fade-up-delay-1">
          Piilu sisse meie hubasetesse ruumidesse ja saa aimu, milline näeb välja
          Prestige Beauty &amp; Wellnessi hoolduskogemus.
        </p>
      </section>

      <section className="bg-ivory py-20 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((src, i) => (
            <button
              key={i}
              onClick={() => setActive(src)}
              className="relative aspect-square overflow-hidden rounded-sm border border-[var(--line)] hover:border-[var(--gold)] transition-all duration-500 group"
            >
              <img
                src={src}
                alt={`Galerii ${i + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setActive(null)}
        >
          <button
            aria-label="Sulge"
            className="absolute top-6 right-6 w-11 h-11 flex items-center justify-center rounded-full bg-white/90 hover:bg-white transition-colors"
            onClick={() => setActive(null)}
          >
            <X className="w-5 h-5 text-brand" strokeWidth={1.5} />
          </button>
          <img
            src={active}
            alt="Galerii suurendus"
            className="max-w-full max-h-full rounded-sm shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
